import React from "react";

import { Button } from "antd";
import Logo from "./Logo";
import { Column, Row } from "core/util-styled-components";
import { useGlobal } from "App/Hooks/global/GlobalContext";
import { Theme } from "theme/Theme";

function Title() {
  const { setBarraActiva } = useGlobal();
  return (
    <Column padding=".1rem 0" style={{ backgroundColor: Theme.colors.primary }}>
      <Row justifyContent="space-between" padding="3px 10px">
        <Logo />
        <Button
          size="small"
          type="text"
          shape="circle"
          onClick={() => setBarraActiva(false)}
        >
          <i className="fa fa-angle-left" style={{ color: "white" }} />
        </Button>
      </Row>
    </Column>
  );
}

export default Title;
